import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  InputAdornment,
  OutlinedInput,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";
import keyIcon from "../assets/images/keyIcon.svg";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useState } from "react";
import { positions, useAlert } from "react-alert";
import axios from "axios";
import { useHistory } from "react-router-dom";
import VerifiedIcon from "@mui/icons-material/Verified";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

const ReEnterPassword = ({ username }) => {
  const history = useHistory();
  const alert = useAlert();
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [loader, setLoader] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfimPassword] = useState(false);
  const [confirmationCode, setConfirmationCode] = useState("");
  const [open, setOpen] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [isResetSuccess, setIsResetSuccess] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleClickShowConfirmPassword = () =>
    setShowConfimPassword((show) => !show);

  const hanldeModalClose = () => {
    setOpen(false);
  };

  const validatePassword = (input) => {
    const hasLength = input.length >= 8;
    const hasUpperCase = /[A-Z]/.test(input); // Check for capital letter
    const hasLowerCase = /[a-z]/.test(input);
    const hasNumber = /[0-9]/.test(input); // Check for number
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(input); // Check for special character
    return (
      hasLength && hasUpperCase && hasLowerCase && hasNumber && hasSpecialChar
    );
  };

  const updateNewPassword = async () => {
    setLoader(true);
    const body = {
      username: username,
      password: newPassword,
      confirmation_code: confirmationCode,
    };
    const modifyPasswordConfig = {
      method: "Post",
      url: "https://jyxmm1ky78.execute-api.ap-south-1.amazonaws.com/Testing/client/resetpassword",
      data: JSON.stringify(body),
    };
    try {
      const modifyPasswordResponse = await axios(modifyPasswordConfig);

      console.log("modifyPasswordResponse", modifyPasswordResponse);
      const isSuccess = modifyPasswordResponse?.data?.isSuccess;
      if (isSuccess) {
        setSuccessMessage(modifyPasswordResponse?.data?.message);
        setIsResetSuccess(true);
      } else {
        const message =
          modifyPasswordResponse?.data?.message ||
          "Counldn't reset password. Please try again";

        alert.error(<span className="alertError">{message}</span>, {
          position: positions.TOP_CENTER,
        });
      }
    } catch (e) {
      alert.error(
        <span className="alertError">
          Something went wrong. Please try again
        </span>,
        {
          position: positions.TOP_CENTER,
        }
      );
    }
    setLoader(false);
  };

  const submitPassword = async (e) => {
    e.preventDefault();
    if (!validatePassword(newPassword)) {
      {
        alert.error(
          <span className="alertError">
            Password with min 8 characters must contain atleast one capital,
            small, number and special character.
          </span>,
          {
            position: positions.TOP_CENTER,
          }
        );
        return;
      }
    }
    if (newPassword !== confirmNewPassword) {
      alert.error(<span className="alertError">Passwords not matching</span>, {
        position: positions.TOP_CENTER,
      });
      return;
    }
    updateNewPassword();
  };

  const successModal = () => {
    return (
      <Dialog
        open={open}
        // onClose={handleModalClose}
        fullWidth
        maxWidth="xs"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Stack alignItems="center" gap={1}>
            <VerifiedIcon sx={{ color: "green", fontSize: "30px" }} />
            <Typography variant="body3">{successMessage}</Typography>
          </Stack>
        </DialogContent>
        <DialogActions>
          <button
            className="btn btn-sm btn-primary"
            onClick={() => {
              history.push("/login");
              hanldeModalClose();
            }}
          >
            Continue to login
          </button>
        </DialogActions>
      </Dialog>
    );
  };

  const SuccessView = () => {
    return (
      <Box>
        <Box
          mb={2}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "70%",
          }}
        >
          <Box
            mb={2}
            sx={{
              outline: "10px solid #F9F5FF",
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              background: "#D1FADF",
            }}
          >
            <CheckCircleOutlineIcon
              sx={{ color: "#039855", fontSize: "24px" }}
            />
          </Box>
          <Typography variant="h5">Password reset</Typography>
          <Typography
            variant="body4"
            sx={{ color: "#475467", fontWeight: 400, textAlign: "center" }}
          >
            Your password has been successfully reset. Click below to log in.
          </Typography>
          <Box mt={2} alignSelf="stretch">
            <Button
              sx={{ width: "100%" }}
              onClick={() => {
                history.push("/login");
              }}
            >
              Continue
            </Button>
          </Box>
        </Box>
      </Box>
    );
  };

  return (
    <Box>
      {!isResetSuccess ? (
        <>
          <Box
            mb={2}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "70%",
            }}
          >
            <Box
              mb={2}
              sx={{
                outline: "10px solid #F9F5FF",
                width: "28px",
                height: "28px",
                borderRadius: "50%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={keyIcon}
                alt="key icon"
                width="80%"
                height="80%"
                style={{ objectFit: "contain" }}
              />
            </Box>
            <Typography variant="h5">Set new password</Typography>
            {/* <Typography
          variant="body4"
          sx={{ color: "#475467", fontWeight: 400, textAlign: "center" }}
        >
          Your new password must be different to previously used passwords.
        </Typography> */}
          </Box>
          <form style={{ width: "70%" }} onSubmit={submitPassword}>
            <Box>
              <Typography variant="body6" mb={1}>
                Password
              </Typography>
              <OutlinedInput
                id="outlined-adornment-password"
                size="small"
                placeholder="Enter your password"
                fullWidth
                type={showPassword ? "text" : "password"}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      // onMouseDown={handleMouseDownPassword}
                      // onMouseUp={handleMouseUpPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
                label=""
                style={{ background: "#fff" }}
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
              <Typography variant="body6" mt={1}>
                Must be at least 8 characters.{" "}
              </Typography>
            </Box>
            <Box mt={2}>
              <Typography variant="body6">Confirm password</Typography>
              <Box>
                <OutlinedInput
                  id="outlined-adornment-password"
                  size="small"
                  placeholder="Re enter your password"
                  fullWidth
                  type={showConfirmPassword ? "text" : "password"}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowConfirmPassword}
                        // onMouseDown={handleMouseDownPassword}
                        // onMouseUp={handleMouseUpPassword}
                        edge="end"
                      >
                        {showConfirmPassword ? (
                          <VisibilityOff />
                        ) : (
                          <Visibility />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                  label=""
                  style={{ background: "#fff" }}
                  value={confirmNewPassword}
                  onChange={(e) => setConfirmNewPassword(e.target.value)}
                />
              </Box>
            </Box>
            <Box my={2}>
              <Typography variant="body6">Confirmation code</Typography>
              <Box>
                <TextField
                  id="outlined-basic"
                  required
                  type="number"
                  fullWidth
                  label=""
                  variant="outlined"
                  size="small"
                  placeholder="Confirmation code recieved in your Email"
                  value={confirmationCode}
                  onChange={(e) => setConfirmationCode(e.target.value)}
                  sx={{ borderRadius: "12px", background: "#fff" }}
                />
              </Box>
            </Box>
            <Box my={2}>
              <Button sx={{ width: "100%" }} type="submit" disabled={loader}>
                {loader ? (
                  <CircularProgress size="20px" sx={{ color: "#fff" }} />
                ) : (
                  "Reset password"
                )}
              </Button>
            </Box>
            <Link to="/login">
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="center"
                gap={1}
              >
                <KeyboardBackspaceIcon sx={{ color: "#475467" }} />
                <Typography variant="body5" sx={{ color: "#475467" }}>
                  Back to login
                </Typography>
              </Stack>
            </Link>
          </form>
        </>
      ) : (
        <SuccessView />
      )}
    </Box>
  );
};

export default ReEnterPassword;
